import React from 'react'
import { useDevice } from 'device'
import { useAb } from 'hooks'
import { constants } from 'helpers'
import { useVisibilityTrigger } from 'intersection-observer'

import SubscribeButton from 'compositions/buttons/SubscribeButton/SubscribeButton'
import BrandsQualityBlock from 'compositions/landings/BrandsQualityBlock/BrandsQualityBlock'

import type { HomePageCustomBlockButton } from 'pages/landing/View/View'

import GetStartedButton from '../GetStartedButton/GetStartedButton'

import messages from './messages'


type BrandsSectionProps = {
  className?: string
  customButton?: HomePageCustomBlockButton
  startButtonMessage?: string | Intl.Message
}

const BrandsSection: React.FunctionComponent<BrandsSectionProps> = (props) => {
  const { className, startButtonMessage, customButton } = props
  const { isMobile } = useDevice()
  const isHomeCopyUpdateAbEnabled = useAb(constants.abTests.homeCopyUpdate) === 'b'

  // TODO: Remove when ab test CRO-216 is over
  const ref = useVisibilityTrigger(() => {
    // TODO: Uncomment the tracking when CRO-216 is launched
    // track('Home brands block display')
  })

  const ButtonComponent = customButton?.actionType === 'subscribe' ? SubscribeButton : GetStartedButton
  const buttonProps = {
    title: startButtonMessage,
    size: 56 as const,
    width: (isMobile ? null : 280 as const),
    fullWidthOnMobile: true,
    className: isMobile ? 'mt-24' : 'mt-32',
    ...customButton,
  }

  const button = (
    <ButtonComponent
      {...buttonProps}
      placement="Brand block"
    />
  )

  return (
    <>
      <div className={className} ref={ref} />
      <BrandsQualityBlock
        className={isMobile ? 'pb-64' : ''}
        subtitle={isHomeCopyUpdateAbEnabled ? messages.subtitle : undefined}
        text={isHomeCopyUpdateAbEnabled ? messages.text : undefined}
        button={button}
      />
    </>
  )
}


export default React.memo(BrandsSection)
